<template>
  <div id="app" class="scrollable">
    <Navbar />
    <router-view v-slot="{ Component }">
      <transition name="page" mode="out-in">
        <component :is="Component" :key="$route.fullPath" />
      </transition>
    </router-view>
    <Footer />
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue';
import Footer from './components/Footer.vue';

export default {
  name: 'App',
  components: {
    Navbar,
    Footer
  },
  mounted() {
    // Fix 100vh issue on mobile browsers by setting CSS variable
    this.setMobileHeight();
    window.addEventListener('resize', this.setMobileHeight);
    
    // Handle orientation changes explicitly
    window.addEventListener('orientationchange', () => {
      setTimeout(this.setMobileHeight, 100); // Small delay after orientation change
    });
    
    // Fix for iOS Safari bounce effect
    document.addEventListener('touchmove', this.handleTouchMove, { passive: false });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.setMobileHeight);
    window.removeEventListener('orientationchange', this.setMobileHeight);
    document.removeEventListener('touchmove', this.handleTouchMove);
  },
  methods: {
    // Fix for mobile 100vh issue - sets a CSS variable with the real viewport height
    setMobileHeight() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    // Prevent pull-to-refresh on mobile
    handleTouchMove(e) {
      // Check if we should block the touch move
      if (e.target && 
          !e.target.closest('.scrollable') && 
          !e.target.closest('.product-modal') &&
          !e.target.closest('input') && 
          !e.target.closest('textarea')) {
        if (e.cancelable) {
          e.preventDefault();
        }
      }
    }
  }
}
</script>

<style>
/* Fix for 100vh issue on mobile */
.full-height {
  height: 100vh; /* Fallback for browsers that don't support custom properties */
  height: calc(var(--vh, 1vh) * 100);
}
</style>